import { AbstractPmsApiService } from "./abstract.service";
import { ScheduledMaintenance } from "../models";

/**
 * @class ScheduledMaintenancePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ScheduledMaintenance>}
 */
export class ScheduledMaintenancePmsApiService extends AbstractPmsApiService {

    /**
     * @propertyType {string}
     * @protected
     */
    get urlPattern() {

        return '/scheduled-maintenance(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ScheduledMaintenance}
     * @protected
     */
    newModel(attributes) {

        return new ScheduledMaintenance(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<ScheduledMaintenance>>}
     */
    get (params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ScheduledMaintenance} scheduledMaintenance
     * @returns {Promise.<ScheduledMaintenance>}
     */
    create(scheduledMaintenance) {

        const url = this.url();

        return this.http
            .post(url, scheduledMaintenance, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} id
     * @param {Object} params
     */
    show(id, params = {}) {

        const url = this.url({
            id: id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ScheduledMaintenance} scheduledMaintenance
     * @returns {Promise.<ScheduledMaintenance>}
     */
    update(scheduledMaintenance) {

        const url = this.url({id: scheduledMaintenance.id});

        return this.http
            .put(url, scheduledMaintenance, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ScheduledMaintenance} scheduledMaintenance
     * @returns {Promise.<boolean>}
     */
    delete(scheduledMaintenance) {

        const url = this.url({id: scheduledMaintenance.id});

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @returns {Promise.<ScheduledMaintenance[]>}
     */
    currentAnnouncements() {

        const url = this.url();

        return this.http
            .get(url + '/current-announcements', {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {ScheduledMaintenance} scheduledMaintenance
     * @returns {Promise.<boolean>}
     */
    hideAnnouncement(scheduledMaintenance) {

        const url = this.url({id: scheduledMaintenance.id});

        return this.http
            .put(url + '/hide', {}, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/scheduled-maintenance.service.js